// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"d3eb7fef","64":"a7fbc301","355":"87cb7f65","965":"a8987896"}[chunkId] + ".chunk.css";
};